/*
 * Cart Order Complete Messages
 *
 * This contains all the text for the cart Order Complete component.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  titleEntitlement: {
    id: 'covert.containers.orderComplete.entitlement.title.label',
    description: 'Title label with entitlement',
  },
  subTitleEntitlement: {
    id: 'covert.containers.orderComplete.entitlement.subtitle.label',
    description: 'Subtitle label with entitlement',
  },
  titleNoProgram: {
    id: 'covert.containers.orderComplete.noprogram.title.label',
    description: 'Title label without entitlementl',
  },
  subTitleNoProgram: {
    id: 'covert.containers.orderComplete.noprogram.subtitle.label',
    description: 'Subtitle label without entitlement',
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/OrderComplete/messages.js